<template>
  <div class="pagina-step">
    <span class="pagina-step-title">Tem equipes novas?</span>
    <v-radio-group v-model="form.equipesNovas" row>
      <div class="container-radio-button">
        <span>Sim</span>
        <v-radio color="primary" :value="true"></v-radio>
      </div>
      <div class="container-radio-button">
        <span>Não</span>
        <v-radio color="primary" :value="false"></v-radio>
      </div>
    </v-radio-group>
    <div class="container-table" v-if="form.equipesNovas">
      <ValidationObserver ref="observer">
        <table>
          <tr>
            <th></th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in equipes" :key="index">
            <td>{{ item.label }}</td>
            <td>
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                  type="text"
                  v-model="item.value"
                  :name="`input_${index}`"
                  v-inputmask="maskNumbers"
                />
                <div class="error">{{ errors[0] }}</div>
              </validation-provider>
            </td>
          </tr>
        </table>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { TheMask } from 'vue-the-mask'
import Masks from '@/mixins/masks'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        equipesNovas: false,
      },
      equipes: [
        { label: 'eSF', key: 'esf', valor_implantacao: 30000, value: '' },
        {
          label: 'eAP 30h',
          key: 'eap_30h',
          valor_implantacao: 16800,
          value: '',
        },
        {
          label: 'eAP 20h',
          key: 'eap_20h',
          valor_implantacao: 10800,
          value: '',
        },
        {
          label: 'eSB 40h',
          key: 'esb_40h',
          valor_implantacao: 14000,
          value: '',
        },
        {
          label: 'eMulti Ampliada',
          key: 'emulti_ampliada',
          valor_implantacao: 36000,
          value: '',
        },
        {
          label: 'eMulti Complementar',
          key: 'emulti_complementar',
          valor_implantacao: 24000,
          value: '',
        },
        {
          label: 'eMulti Estratégica',
          key: 'emulti_estrategica',
          valor_implantacao: 12000,
          value: '',
        },
      ],
    }
  },
  mounted() {
    if (this.dados?.etapa5 !== null) {
      const etapa5 = this.dados?.etapa5
      this.form.equipesNovas = etapa5.equipesNovas
      if (etapa5.equipesNovas) {
        this.equipes[0].value = this.encontrarEquipe(
          etapa5.equipes,
          'esf'
        ).value
        this.equipes[1].value = this.encontrarEquipe(
          etapa5.equipes,
          'eap_30h'
        ).value
        this.equipes[2].value = this.encontrarEquipe(
          etapa5.equipes,
          'eap_20h'
        ).value
        this.equipes[3].value = this.encontrarEquipe(
          etapa5.equipes,
          'esb_40h'
        ).value
        this.equipes[4].value = this.encontrarEquipe(
          etapa5.equipes,
          'emulti_ampliada'
        ).value
        this.equipes[5].value = this.encontrarEquipe(
          etapa5.equipes,
          'emulti_complementar'
        ).value
        this.equipes[6].value = this.encontrarEquipe(
          etapa5.equipes,
          'emulti_estrategica'
        ).value
      }
    }
  },
  computed: {
    cidadeEstado() {
      return `${this.dados?.etapa1.cidade.no_municipio} - ${this.dados?.etapa1.estado.uf}`
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  methods: {
    encontrarEquipe(data, key) {
      return data.find((el) => el.key == key)
    },
    salvarDados() {
      this.$emit('dados-etapa', {
        etapa: 'etapa5',
        dados: {
          equipesNovas: this.form.equipesNovas,
          equipes: this.form.equipesNovas ? this.equipes : null,
        },
      })
    },
    voltar() {
      this.$emit('etapa-anterior')
    },
    proximo() {
      if (this.form.equipesNovas) {
        this.$refs.observer.validate().then((success) => {
          if (success) {
            this.salvarDados()
            this.$emit('proxima-etapa')
          } else {
            this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
              position: 'topRight',
            })
          }
        })
      } else {
        this.salvarDados()
        this.$emit('proxima-etapa')
      }
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />

<style scoped>
.container-radio-button {
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>
<style scoped lang="scss">
table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 30px;
  @media screen and (max-width: 656px) {
    margin-bottom: 0;
  }
}
th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
  width: 50%;
  input {
    height: auto !important;
    background-color: #fff;
    margin-bottom: 0 !important;
  }
}
th {
  background-color: #156082;
  color: white;
}

.container-buttons {
  justify-content: center !important;
}

@media screen and (max-width: 656px) {
  .container-table {
    overflow: auto;
    margin-bottom: 15px;
  }
  .container-buttons {
    gap: 20px;
    align-items: center;
  }
}
</style>
